import { useNuxtApp } from "#imports";
export const usePDFMake = () => {
  return useNuxtApp().$pdfMake;
};
